import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useDispatch } from "react-redux";
import { Icon, ProgressIndicator } from "rhombus-react";

//import useFileSelector from "hooks/useFileSelector";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

import { fetchAssetDetail } from "reducers/Assets";

import AssetThumbnail from "social/AssetThumbnail";

import { ASSET_TYPES, CREATIVE_ASSET_TYPES } from "utils/constants";

import SelectAssets from "widgets/modals/assets/SelectAssets";
import {
	//getImageMetadata,
	//getVideoMetadata,
	getImageAssetMetadata,
	getVideoAssetMetadata
} from "widgets/forms/validators/Assets";

import "./AssetSelect.css";

export default function AssetSelect(props) {
	const {
		input,
		meta,
		assetType,
		accept,
		multiple,
		label = `Select ${assetType}`,
		prompt = "Select Asset",
		libraryId,
		tip,
		helpTip,
		requirements,
		navigationActions: { pushModal, popModal },
		required,
		className,
		disabled,
		thumbnailDisabled,
		showPristineErrors,
		showName,
		showIcon,
		iconName,
		configureFilter,
		creativeAssetType,
		pre,
		detail,
	} = props;

	const { value: details = {}, onChange, onBlur, onFocus } = input;
	let { error, warning, touched, valid } = meta;

	const isVideo = assetType === ASSET_TYPES.VIDEO;

	const dispatch = useDispatch();
	useTooltipRebuild();

	/* const selectFiles = useFileSelector(async (event) => {
		if (disabled) { return; }

		let [file] = event.target.files;
		if (!file) { return; }

		let src = URL.createObjectURL(file);
		let formData = new FormData();
		formData.append("files", file);

		let metadataGetter = isVideo ? getVideoMetadata : getImageMetadata;

		try {
			let metadata = await metadataGetter(src);
			metadata.filesize = file.size;

			handleChange({
				// Fields expected for API
				src,
				hasInline: true,
				formData,
				name: file.name,
				id: "uploaded-asset",

				metadata, // For validation
			});
		} catch {
			handleChange(null);
		}
	}, {
		accept,
		multiple,
	}); */
	const [isLoadingAsset, setIsLoadingAsset] = useState(Boolean(!isVideo && details.id));

	let inputProps = {
		iconName: iconName || `asset${assetType}`,
		prompt,
		disabled: disabled || !Boolean(libraryId),
		thumbnailDisabled,
	};

	const isAdStudio = creativeAssetType === CREATIVE_ASSET_TYPES.ADSTUDIO;
	const isImposium = creativeAssetType === CREATIVE_ASSET_TYPES.IMPOSIUM;
	const isAfterEffects = creativeAssetType === CREATIVE_ASSET_TYPES.AFTER_EFFECTS;

	if(isAdStudio){
		inputProps.prompt = "Ad Studio";
		inputProps.iconName = "far fa-palette";
		inputProps.disabled = true;
		inputProps.thumbnailDisabled = true;
	} else if (isImposium){
		inputProps.prompt = "Imposium";
		inputProps.iconName = "far fa-paintbrush-pencil";
		inputProps.disabled = true;
		inputProps.thumbnailDisabled = true;
	} else if (isAfterEffects){
		inputProps.prompt = "After Effects";
		inputProps.iconSrc = "/images/ae-project.png";
		inputProps.disabled = true;
		inputProps.thumbnailDisabled = true;
	}

	function onSelect(values) {
		const [id] = values;

		onChange({ id });
		onBlur();

		dispatch(fetchAssetDetail(libraryId, assetType, id))
			.then((resp) => {
				if (resp.success && resp.payload?.data) {
					const { data } = resp.payload;
					let fileName, metadata;

					if(isVideo){
						setIsLoadingAsset(false); // Videos do not have a preview

						fileName = data.name;
						metadata = getVideoAssetMetadata(data);
					} else {
						fileName = data.filename;
						metadata = getImageAssetMetadata(data);
					}

					onChange({
						id: data.id,
						hasInline:false,
						src: data.url,
						name: fileName,

						metadata, // For validation
					});
				}
			});
	}

	/* function handleChange(value) {
		onBlur();

		if (!isVideo) {
			setIsLoadingAsset(true); // Images have a preview to load
		}

		onChange(value);
	} */

	function handleRemove() {
		if (inputProps.disabled) { return; }

		onFocus();
		onChange(null);
	}

	function handleSelect() {
		if (inputProps.disabled) { return; }

		onFocus();
		openSelectionModal();
	}

	function openSelectionModal() {
		function Configured(props){
			let modalProps = {
				...props,
				type: assetType.toLowerCase(),
				onSelect,
				accept,
				multiple,
				configureFilter,
				onClose: popModal,
			};
			return <SelectAssets {...modalProps} />;
		}
		pushModal(Configured);
	}

	let clearButton;
	const icon = inputProps.iconSrc ? (<img className="asset-type-icon" src={inputProps.iconSrc} alt={inputProps.prompt} />) : (<Icon name={inputProps.iconName} />);
	let content = (
		<div
			className="asset-input tip"
			data-tip={tip.description}
			data-html={tip.html}
		>
			{showIcon ? icon : null}
			{/* <span>
				<a onClick={selectFiles}className={classNames("asset-upload-link", { disabled: isDisabled })}>
					Upload
				</a>
				or
			</span> */}
			<a className={classNames("asset-upload-link", { disabled: inputProps.disabled })} href="#" onClick={handleSelect}>
				{inputProps.prompt}
			</a>
		</div>
	);


	// If there is an asset selected, show a thumbnail instead
	if (details.id && !inputProps.thumbnailDisabled) {
		content = (
			<div
				className="asset-preview tip"
				data-tip={details.name}
				direction="top"
			>
				<ProgressIndicator isLoading={isLoadingAsset} />
				<AssetThumbnail
					libraryId={libraryId}
					onLoad={() => setIsLoadingAsset(false)}
					assetType={assetType}
					details={details}
				/>
			</div>
		);

		clearButton = disabled ? null : <Icon className="clear-button" name="clear" onClick={handleRemove} />;
	}

	const hasError = (showPristineErrors || touched) && error;
	const hasWarning = (showPristineErrors || touched) && warning;

	let $message;

	// We give warnings precedence to match Rhombus
	if (hasWarning) {
		if (Array.isArray(warning)) {
			warning = warning.map(msg => <React.Fragment key={msg}>{msg}<br /></React.Fragment>);
		}
		$message = <div className="warning-message has-warning">{warning}</div>;
	} else if (hasError) {
		if (Array.isArray(error)) {
			warning = error.map(msg => <React.Fragment key={msg}>{msg}<br /></React.Fragment>);
		}
		$message = <div className="warning-message has-error">{error}</div>;
	}

	return (
		<div
			className={classNames(
				className,
				"asset-select-wrapper e-form__control-wrapper",
				{
					required,
					"e-form--valid": Boolean(input?.value?.id && valid),
					"e-form--error": hasError,
					"e-form--warn": hasWarning,
					"e-form--has-message": hasError || hasWarning,
				}
			)}
		>
			<div className="e-form__control-header">
				<label className="e-form__control-label">
					{label}
				</label>
				{helpTip ? <Icon name="help-tip fas fa-info-circle" data-tip={helpTip} /> : null}
				{detail ? <div className="detail">{detail}</div> : null}
			</div>
			<div className="asset-select">
				<div className="asset-view">
					{ pre ? <div className="inline-content pre-content">{pre}</div> : null }
					{clearButton}
					{content}
				</div>
				{requirements.length > 0 && (
					<div className="requirements">
						<div className="title">{assetType} Requirements</div>
						<table>
							<tbody className="asset-select-requirements">
								{requirements.map(({ name, description }) => (
									<tr key={name}>
										<td>{name}</td>
										<td>{description}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
			{$message}
			{(showName && details.name) ? <div title={details.name} className="asset-name name-overflow">{details.name}</div> : null}
		</div>
	);
}

AssetSelect.displayName = "AssetSelect";

AssetSelect.propTypes = {
	assetType: PropTypes.oneOf(Object.values(ASSET_TYPES)).isRequired,
	libraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	accept: PropTypes.string.isRequired,
	navigationActions: PropTypes.shape({
		pushModal: PropTypes.func.isRequired,
	}).isRequired,

	className: PropTypes.string,
	label: PropTypes.node,
	prompt: PropTypes.string,
	requirements: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		description: PropTypes.string,
	})),
	required: PropTypes.bool,
	tip: PropTypes.shape({
		description: PropTypes.string.isRequired,
		html: PropTypes.bool,
	}),
	helpTip: PropTypes.string,
	disabled: PropTypes.bool,
	thumbnailDisabled: PropTypes.bool,
	showPristineErrors: PropTypes.bool,
	showName: PropTypes.bool,
	showIcon: PropTypes.bool,
	configureFilter: PropTypes.func,
	creativeAssetType: PropTypes.oneOf(Object.values(CREATIVE_ASSET_TYPES)),

	pre: PropTypes.node,
	detail: PropTypes.node,
};

AssetSelect.defaultProps = {
	className: "",
	requirements: [],
	tip: {
		description: "",
		html: false,
		direction: "top",
	},
	helpTip: "",
	prompt: "Select Asset",
	required: false,
	disabled: false,
	thumbnailDisabled: false,
	showPristineErrors: false,
	showName: false,
	showIcon: true,
	iconName: "",
	configureFilter: null,

	pre: null,
	detail: null,
};
